// extracted by mini-css-extract-plugin
export default {"container":"comment-list_container__o9J3E","circular-progress":"comment-list_circular-progress__REq7s","comments-list":"comment-list_comments-list__LwAYM"};